const defaultUnitFieldValues = {
    // inOut: 'I',
    unitKind: ' ',
    //empty: "1", //TODO: setting this to true gives error: "Invalid initialValue supplied to Input"
    rid: 0,
    pos: 'F',
    good: {
        hzd: false,
        hzdData: {
            ridReg: 'ADR'
        },
        open: false,
        packagingUnity: 'PAL'
    },
    doc: {
        type: 'T1        '
    }
};

export default defaultUnitFieldValues;